function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);``
  };
}

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.search = {}

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    this.querySelector('button[type="button"]:not(.search-modal__clear-input)').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');

    this.headerDraver = document.querySelector('.header__mobile header-drawer')
    this.searchButton = this.querySelector('.search-modal__content-search-button');
    this.defaultWrapper = this.querySelector('.search-modal__content-inner:not(.search-modal__content-inner--result)');
    this.resultWrapper = this.querySelector('.search-modal__content-inner.search-modal__content-inner--result');

    this.resultProductHeading = this.resultWrapper.querySelector('.search-modal__content-heading');

    this.resultProductWrapper = this.resultWrapper.querySelector('.search-modal__content-products');

    this.resulLists = this.resultWrapper.querySelector('.search-modal__content-list');
    this.resultContentList = this.resulLists.querySelector('.search-modal__content-item-content');
    this.resultSuggestionsList = this.resulLists.querySelector('.search-modal__content-suggestion');
    this.resultButton = this.resulLists.querySelector('.search-modal__content-list-button');
    this.searchInput = this.detailsContainer.querySelector('input:not([type="hidden"].search-modal__content-search-input)');
    this.requestValueSpan = document.querySelector('.search-results .request-value');
    this.buttonClearValue = this.querySelector('.search-modal__clear-input');

    setTimeout(()=> {
      if (this.searchInput.value.length) {
        this.setRequestValue(this.searchInput.value);
      } else {
        this.setRequestValue();
      }
    }, 1500);

    const debouncedOnInput = debounce((event) => {
      if (this.searchInput.value.length) {
        this.hideSearchButton(this.searchInput.value);
        this.requestToIPA(this.searchInput.value)
        this.changeContent(true, false);
      } else {
        this.hideSearchButton();
        this.changeContent(false, true);
      }
    }, 350);

    this.searchInput.addEventListener('input', debouncedOnInput.bind(this));

    this.buttonClearValue?.addEventListener('click', ()=> {
      this.searchInput.value = '';

      setTimeout(()=>{
        this.searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.searchInput.focus();
      })
    });
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay') || event.target.classList.contains('nize-ac-results')) {
      this.close(false);
    }
  }

  open(event) {
    if (this.headerDraver.querySelector('details').getAttribute('open')) this.headerDraver.closeMenuDrawer(event);

    if (event.target.closest('details').getAttribute('open')) return;

    const customEvent = new Event('input', { bubbles: true });
    this.searchInput.dispatchEvent(customEvent);
    event.preventDefault();

    setTimeout(()=> {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

      event.target.closest('details').setAttribute('open', true);
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');

      trapFocus(
        this.querySelector('details')
      );

      this.searchInput.nextElementSibling.classList.contains('search-modal__content-search-input-label') ? false : this.searchInput.focus();
    }, 400);
  }

  requestToIPA(value) {

    const url = `https://searchserverapi.com/getwidgets?api_key=0M4R3o5G1f&q=${value}&items=true&suggestions=true&&categories=true&pages=true&output=json`

    fetch(url)
      .then(response => response.json())
      .then(data => {
        const promisesProducts = ()=> {
          this.currentProducts = [];
          const arrData = Array.from(data.items)
          const iterationLength = arrData.length >= 3 ? 3 : arrData.length

          for(let i = 0; i < iterationLength; i++) {
            const promiseProducts = new Promise((resolve, reject) => {
              resolve(this.renderProduct(arrData[i]));
            });

            this.currentProducts.push(promiseProducts);
          }

          return this.currentProducts.length ? this.currentProducts : false
        };

        if (promisesProducts()) {
          Promise.all(promisesProducts()).then(response => {

            this.resultProductHeading.setAttribute('aria-hidden', 'false')
            this.resultProductWrapper.innerHTML = response.join('');
          });
        } else {
          this.resultProductHeading.setAttribute('aria-hidden', 'true')
          this.resultProductWrapper.innerHTML = `<p>No product results found for <strong>${value}</strong>. <a href="/collections/all">Explore our products here.</a></p>`
        }

        const promisesContent = ()=> {
          this.currentContentList = [];

          for(let i = 0; i < 3; i++) {
            if (!data.pages[i]) return false;

            const promise = new Promise((resolve, reject) => {
              resolve(this.renderList(data.pages[i]));
            });

            this.currentContentList.push(promise);
          }
          return this.currentContentList
        };

        if (promisesContent()) {
          Promise.all(promisesContent()).then(response => {

            this.resultContentList.querySelector('.search-modal__content-item-child-list').innerHTML = response.join('');
            this.resultContentList.setAttribute('aria-hidden', 'false')
          });
        } else {
          this.resultContentList.setAttribute('aria-hidden', 'true')
        }

        const promisesSuggestion = ()=> {
          this.currentSuggestionList = [];

          for(let i = 0; i < 3; i++) {

            if (!data.suggestions[i]) return false;

            const promise = new Promise((resolve, reject) => {
              resolve(this.renderList(data.suggestions[i]));
            });

            this.currentSuggestionList.push(promise);
          }
          return this.currentSuggestionList
        };

        if (promisesSuggestion()) {
          Promise.all(promisesSuggestion()).then(response => {

            this.resultSuggestionsList.querySelector('.search-modal__content-item-child-list').innerHTML = response.join('');
            this.resultSuggestionsList.setAttribute('aria-hidden', 'false')
          });
        } else {
          this.resultSuggestionsList.setAttribute('aria-hidden', 'true')
        }

        if (data.pages.length || data.items.length) {
          this.buttonChange(value);
        } else {
          this.buttonChange(false);
        }

        this.hideSearchButton(value);

      })
      .catch(error => console.error(error));
  }

  hideSearchButton(value = false) {
    if (value) {
      this.searchButton.setAttribute('aria-hidden', 'true');
    } else {
      this.searchButton.setAttribute('aria-hidden', 'false');
    }
  }

  setRequestValue(value = false) {   // Додавання значення запиту до заголовку сторінки результату ??????
    if(!this.requestValueSpan) return;

    if (value) {
      this.requestValueSpan.setAttribute('aria-hidden', 'false');
      this.requestValueSpan.querySelector('span').innerHTML = value;
    } else {
      this.requestValueSpan.setAttribute('aria-hidden', 'true');
    }
  }

  changeContent(defaultWrapper, resultWrapper) {
    if (defaultWrapper) {
      this.defaultWrapper.setAttribute('aria-hidden', 'true')
    } else {
      this.defaultWrapper.setAttribute('aria-hidden', 'false')
    }

    if (resultWrapper) {
      this.resultWrapper.setAttribute('aria-hidden', 'true')
    } else {
      this.resultWrapper.setAttribute('aria-hidden', 'false')
    }
  }

  renderProduct(obj) {
    return `<div class="search-modal__content-product-wrapper">
              <div class="search-modal__content-product-image-wrapper" role="contentinfo">
                <a class="search-modal__content-product-image-link" 
                  href="${obj.link}" 
                  title="${obj.title}" 
                  aria-label="Product link"
                  tabIndex="-1"
                  aria-hidden="true">
                
                <img class="search-modal__content-product-image lazyload"
                     src="${obj.image_link}"
                     alt="${obj.shopify_images_alt[0]}" width="100%" height="100%">
                     </a>
               </div>
              <h4 class="search-modal__content-product-heading">
                <a class="search-modal__content-product-heading-link"
                   href="${obj.link}"
                   title="${obj.title}"
                   aria-label="Product link"
                   tabIndex="-1"
                   aria-hidden="true">${obj.title}</a>
              </h4>
              <a href="${obj.link}" class="button button--primary">shop now</a>
            </div>`
  }

  renderList(obj) {
    if (typeof obj === 'object') {
      return `<li class="search-modal__content-item-child-item">
              <a class="search-modal__content-item-child-item-title" href="${obj.link}">${obj.title}</a>
            </li>`
    } else {
      const currentUrl = `${routes.root_url}pages/search-results-page?q=${obj}`

      return `<li class="search-modal__content-item-child-item">
              <a class="search-modal__content-item-child-item-title" href="${currentUrl}">${obj}</a>
            </li>`
    }
  }

  buttonChange(string) {
    if(string) {
      const currentUrl = `${routes.root_url}pages/search-results-page?q=${string}`

      this.resultButton.innerHTML = `search all “${string}”`
      this.resultButton.href = currentUrl
      this.resultButton.setAttribute('aria-hidden', 'false');
    } else {
      this.resultButton.setAttribute('aria-hidden', 'true');
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);